/** URL do rodapé fixo (texto: © ano + nome do painel). */
export const PANEL_FOOTER_URL = 'https://licenses.sshtproject.com'
